// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { AttributeValueModel } from "@insite/client-framework/Types/ApiModels";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { FC } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import translate from "@insite/client-framework/Translate";
import { attributesProps } from "@store/Themes/common/props/attributes";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
/* Starter Custom Code - End */

interface OwnProps {
    maximumNumberAttributeTypes: number;
    extendedStyles?: ProductAttributesStyles;
    // Starter Custom Code
    overridedStyles?: ProductAttributesStyles;
}

type Props = OwnProps & HasProduct;

export interface ProductAttributesStyles {
    container?: GridContainerProps;
    attributeTypeGridItem?: GridItemProps;
    attributeValueGridItem?: GridItemProps;
    attributeTypeText?: TypographyPresentationProps;
    attributeValueText?: TypographyPresentationProps;
}

export const productAttributesStyles: ProductAttributesStyles = {
    container: attributesProps.container,
    attributeTypeGridItem: attributesProps.item,
    attributeTypeText: attributesProps.label,
    attributeValueText: attributesProps.value,
};

const ProductAttributes: FC<Props> = ({
    product: { attributeTypes },
    maximumNumberAttributeTypes,
    extendedStyles,
    // Starter Custom Code
    overridedStyles,
}) => {
    const styles = useExpandProps(productAttributesStyles, extendedStyles, overridedStyles); // Starter Custom Code

    if (!attributeTypes || attributeTypes.length === 0) {
        return null;
    }

    const maximum = Math.min(maximumNumberAttributeTypes, 100);
    const limitedAttributeTypes = attributeTypes.slice(0, maximum);

    const displayAttributeValues = (attributeValues: AttributeValueModel[] | null) => {
        return (
            <Typography {...styles.attributeValueText}>
                {(attributeValues ?? []).map(a => a.valueDisplay).join(", ")}
            </Typography>
        );
    };

    return (
        <GridContainer {...styles.container}>
            {limitedAttributeTypes.map(attributeType => (
                <React.Fragment key={attributeType.id.toString()}>
                    <GridItem {...styles.attributeTypeGridItem}>
                        <Typography
                            {...styles.attributeTypeText}
                            data-test-selector={`attributeType${attributeType.id}`}
                        >
                            {translate("{0}:", attributeType.label || attributeType.name) /* Starter Custom Code */}
                        </Typography>
                        {displayAttributeValues(attributeType.attributeValues) /* Starter Custom Code */}
                    </GridItem>
                    {/* Starter Removed - attributeValueGridItem */}
                </React.Fragment>
            ))}
        </GridContainer>
    );
};

export default withProduct(ProductAttributes);
